import SceneTransition from "./SceneTransition";

interface TransitionWithDirection {
    in: string;
    out: string;
    duration?: number;
}

interface SwipeDirection {
    up?: string;
    down?: string;
    left?: string;
    right?: string;
}

interface TransitionType {
    id: string;
    label: string;
    forwardTransition: TransitionWithDirection;
    reverseTransition: TransitionWithDirection;
    swipeDirections: SwipeDirection;
    supportSwipes: boolean;
    allowPageScroll?: string;
}

/**
 * Enumeration of scene transition types.
 * TS "enum" with custom type based on:
 * https://stackoverflow.com/questions/41179474/use-object-in-typescript-enum
 */
class SceneTransitionTypes {
    static readonly NONE = new SceneTransitionTypes('NONE', {
        id: "none",
        label: "None",

        forwardTransition: {
            in: SceneTransition.MOVE_FROM_RIGHT,
            out: SceneTransition.MOVE_TO_LEFT,
            duration: 0
        },

        reverseTransition: {
            in: SceneTransition.MOVE_FROM_LEFT,
            out: SceneTransition.MOVE_TO_RIGHT,
            duration: 0
        },

        swipeDirections: {},

        supportSwipes: false
    });

    static readonly SLIDE_FROM_TOP = new SceneTransitionTypes('SLIDE_FROM_TOP', {
        id: "slide-from-top",
        label: "Slide Down",

        forwardTransition: {
            in: SceneTransition.MOVE_FROM_TOP,
            out: SceneTransition.MOVE_TO_BOTTOM
        },

        reverseTransition: {
            in: SceneTransition.MOVE_FROM_BOTTOM,
            out: SceneTransition.MOVE_TO_TOP
        },

        swipeDirections: {
            up: "reverse",
            down: "forward"
        },

        supportSwipes: true,
        allowPageScroll: "horizontal"
    });

    static readonly SLIDE_FROM_BOTTOM = new SceneTransitionTypes('SLIDE_FROM_BOTTOM', {
        id: "slide-from-bottom",
        label: "Slide Up",

        forwardTransition: {
            in: SceneTransition.MOVE_FROM_BOTTOM,
            out: SceneTransition.MOVE_TO_TOP
        },

        reverseTransition: {
            in: SceneTransition.MOVE_FROM_TOP,
            out: SceneTransition.MOVE_TO_BOTTOM
        },

        swipeDirections: {
            up: "forward",
            down: "reverse"
        },

        supportSwipes: true,
        allowPageScroll: "horizontal"
    });

    static readonly SLIDE_FROM_LEFT = new SceneTransitionTypes('SLIDE_FROM_LEFT', {
        id: "slide-from-left",
        label: "Slide Right",

        forwardTransition: {
            in: SceneTransition.MOVE_FROM_LEFT,
            out: SceneTransition.MOVE_TO_RIGHT
        },

        reverseTransition: {
            in: SceneTransition.MOVE_FROM_RIGHT,
            out: SceneTransition.MOVE_TO_LEFT
        },

        swipeDirections: {
            left: "reverse",
            right: "forward"
        },

        supportSwipes: true,
        allowPageScroll: "vertical"
    });

    static readonly SLIDE_FROM_RIGHT = new SceneTransitionTypes('SLIDE_FROM_RIGHT', {
        id: "slide-from-right",
        label: "Slide Left",

        forwardTransition: {
            in: SceneTransition.MOVE_FROM_RIGHT,
            out: SceneTransition.MOVE_TO_LEFT
        },

        reverseTransition: {
            in: SceneTransition.MOVE_FROM_LEFT,
            out: SceneTransition.MOVE_TO_RIGHT
        },

        swipeDirections: {
            left: "forward",
            right: "reverse"
        },

        supportSwipes: true,
        allowPageScroll: "vertical"
    });

    static readonly FADE = new SceneTransitionTypes('FADE', {
        id: "fade",
        label: "Fade",

        forwardTransition: {
            in: SceneTransition.FADE_IN,
            out: SceneTransition.FADE_OUT
        },

        reverseTransition: {
            in: SceneTransition.FADE_IN,
            out: SceneTransition.FADE_OUT
        },

        swipeDirections: {},

        supportSwipes: false
    });

    private constructor(private key: string, public readonly value: TransitionType) {
    }

    toString() {
        return this.key;
    }

}

export {SceneTransitionTypes as default, SceneTransitionTypes};




// WEBPACK FOOTER //
// ./src/shared/ui/experience/SceneTransitionTypes.ts